import React, { useCallback } from "react";
import { useSelector } from "react-redux";
// HOOKS
import useOperationData from "../../hooks/operationData";
// CONSTS
import { XRAY_WELCOME_MESSAGE } from "../../types/welcomeMessages";
// APP COMPONENTS
import OrdersHeatMap from "./OrdersHeatMap";
import WeatherDisplay from "./WeatherDisplay";
import AssistantWelcome from "./AssistantWelcome";
// MATERIAL UI
import Box from "@mui/material/Box";
import Fade from "@mui/material/Fade";
import Grid from "@mui/material/Grid";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { CustomModalRoot } from "../styled/modal";
import { StyledDarkGreyBadge } from "../styled/badge";
import { LightDarkGreyBox, LightGreyBox } from "../styled";
// ICONS
import CloseIcon from "@mui/icons-material/Close";
import TimerIcon from "@mui/icons-material/Timer";
import AssistantIcon from "@mui/icons-material/Assistant";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import { orange } from "@mui/material/colors";

const OperationDataModal = ({ show, closeModal }) => {
  const userId = useSelector((state) => state.auth?.user?.username);

  const {
    loading,
    predictedOrdersNextHour,
    averagePreparationTime,
    showWelcome,
    setShowWelcome,
  } = useOperationData(show, userId);

  const handleCloseWelcome = useCallback(() => {
    const completedUsers =
      JSON.parse(localStorage.getItem("operationDataWelcomeSlapie")) || [];

    localStorage.setItem(
      "operationDataWelcomeSlapie",
      JSON.stringify([...completedUsers, userId])
    );
    setShowWelcome(false);
  }, [setShowWelcome, userId]);

  const handleCloseModal = useCallback(
    (e) => {
      closeModal(e);
    },
    [closeModal]
  );

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={show}
      onClose={handleCloseModal}
      closeAfterTransition
      sx={{ zIndex: 9999 }}
    >
      <Fade in={show} mountOnEnter unmountOnExit>
        <CustomModalRoot
          top={45}
          left={50}
          width={70}
          height={90}
          overflow={"auto"}
          display="block"
        >
          <LightDarkGreyBox
            display="flex"
            justifyContent="space-between"
            marginBottom={2}
          >
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <AssistantIcon />
              <Typography variant="h6" sx={{ ml: 1 }}>
                ANALISTA SLAPIE
              </Typography>
            </Box>
            <IconButton aria-label="close-modal" onClick={handleCloseModal}>
              <CloseIcon />
            </IconButton>
          </LightDarkGreyBox>

          <LightDarkGreyBox sx={{ mb: 1 }}>
            <Typography
              variant="body1"
              textAlign="center"
              color={orange["800"]}
            >
              Painel ainda em desenvolvimento, em caso de dúvidas ou dados
              incorretos favor contatar o suporte.
            </Typography>
          </LightDarkGreyBox>

          {showWelcome && (
            <AssistantWelcome
              message={XRAY_WELCOME_MESSAGE}
              onClose={handleCloseWelcome}
            />
          )}

          <Box padding={4}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={6}>
                <WeatherDisplay />
                <LightGreyBox
                  sx={{
                    mt: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <TimerIcon sx={{ mr: 1 }} />
                  <Typography variant="body1">
                    Tempo Médio de Preparo:
                  </Typography>
                  <StyledDarkGreyBadge sx={{ ml: 1 }}>
                    <Typography variant="body1">
                      {parseFloat(averagePreparationTime).toFixed(0) || 0} min
                    </Typography>
                  </StyledDarkGreyBadge>
                </LightGreyBox>
                <LightGreyBox
                  sx={{
                    mt: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Box
                    sx={{
                      mt: 1,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <ShoppingBasketIcon sx={{ mr: 1 }} />
                    <Typography variant="body1">Pedidos Esperados:</Typography>
                    <StyledDarkGreyBadge sx={{ ml: 1 }}>
                      <Typography variant="body1">
                        {predictedOrdersNextHour} na próxima hora
                      </Typography>
                    </StyledDarkGreyBadge>
                  </Box>
                </LightGreyBox>
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <Box sx={{ height: 500 }}>
                  <OrdersHeatMap sx={{ height: 500 }} />
                </Box>
                <Typography variant="subtitle2" textAlign="right">
                  *Dados referentes às últimas 6 horas
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </CustomModalRoot>
      </Fade>
    </Modal>
  );
};

export default OperationDataModal;
